import 'jssocials/dist/jssocials.min'

$(document).ready(function () {
	"use strict";
	$(".prettySocial").jsSocials({
		showLabel: false,
		showCount: false,
		shareIn: "popup",
		shares: ["facebook", "twitter", "whatsapp"]
	});
});


// WEBPACK FOOTER //
// ./scripts/elements/_prettySocial.js